import React, { useEffect, useState } from "react";
import { config } from "../utils/config";
import { Button } from "reactstrap";
import { NavLink, useNavigate } from "react-router-dom";
import moment from "moment";
import { getSubscriptionStatus } from "../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { getPlanDetails } from "../redux/slices/PlanDetailSlice";

export default function VariationCountLabel({ userPlanDetails }) {
  
  const dispatch = useDispatch(); 
  const navigate = useNavigate();
  userPlanDetails = useSelector((state) => state?.userPlan?.userPlanDetails?.[0]);
  const userData = useSelector(state => state?.user?.userData);

  const planDetails = userPlanDetails;
  const totalVariant = parseInt(userPlanDetails?.total_variant || 0); 
  const totalVariantDownloaded = parseInt(userPlanDetails?.variant_count || 0); 
  const variantCount = parseInt(totalVariant - totalVariantDownloaded);


  useEffect(() => {
    dispatch(getPlanDetails()); 
  }, []); 


  if(!planDetails) return null;

  if (
    planDetails &&
    // planDetails.type?.trim().toLowerCase() === "unlimited" &&
    planDetails.plan_id === 7 &&
    planDetails.status?.trim().toLowerCase() === "active" &&
    planDetails.subscription_status?.trim().toLowerCase() === "active"
  ) {
    return null;
  }
  
  if (
    planDetails &&
    (planDetails?.type === "Free" || planDetails?.type === "Prepaid")
  ) {
    return (
      <div className="imageGenerateUpgradeBlock">
        <div className="imageGenerateUpgrade">
          <img src="/assets/images/warning_icn.svg" />
          {variantCount > 0 ? (
            <>
              <p>
                {variantCount} Image
                {variantCount > 1 ? "s" : ""} you can generate
              </p>
              <Button
                color="create_variations"
                onClick={() => {
                  navigate("/plans");
                }}
              >
                Upgrade Now
              </Button>
            </>
          ) : (
            <>
              <p>
                You can not generate more images
              </p>
              <Button
                color="create_variations"
                onClick={() => {
                  navigate("/plans");
                }}
              >
                Upgrade Now
              </Button>
            </>
          )}
        </div>
      </div>
    );
  } else {
    return (
      <div className="imageGenerateUpgrade">
        <p>
          {getSubscriptionStatus(planDetails)}
        </p>

        <Button
          color="create_variations"
          onClick={() => {
            navigate(`/plans?email=${userData?.email}`);
          }}
        >
          Upgrade Now

        </Button>
      </div>
    );
  }
}